import DefaultList from "@Common/DefaultList";
import { useNavigationHandler } from "@hook";
import { getStatusTag, handleCopyBuffer } from "@utils";
import { inject, observer } from "mobx-react";

import { Tag } from "primereact/tag";

const ProjectsList = inject("mainStore")(
    observer(({ mainStore }) => {
        const navigation = useNavigationHandler();

        const handleRowClick = (e) => {
            mainStore.setMainStore("detailData", {});
            navigation(e.originalEvent, `/projects/${e.data._id}`);
        };

        return (
            <DefaultList
                dataKey={"promo_vendor"}
                apiUrl="/promo/sites"
                keysToGet={["_id", "name", "active", "archived", "draft", "domain", "siteInfo.placementType"]}
                titleName="Витрины"
                keyFilterSearch="name"
                handleRowClick={handleRowClick}
                checkbox={false}
                columns={[
                    {
                        field: "_id",
                        header: "ID",
                        style: { width: "10%", maxWidth: "300px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        body: (item) => (
                            <div className="id__copy cursor-pointer" onClick={(e) => handleCopyBuffer(e, item, "_id", (val) => mainStore.setMainStore("toast", { severity: "success", life: 4000, summary: `Скопировано`, detail: val }))}>
                                <span className=" text">ID</span>
                                <i className="pi pi-clone"></i>
                            </div>
                        ),
                    },
                    {
                        field: "name",
                        header: "Название",
                        body: (item) => <span className="list__name">{item.name}</span>,
                        style: { width: "300px", maxWidth: "300px" },
                        sortable: true,
                    },

                    {
                        field: "domain",
                        header: "Домен",
                        style: { width: "300px", maxWidth: "300px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        sortable: true,
                    },
                    {
                        field: "siteInfo.placementType",
                        header: "Тип оплаты",
                        style: { maxWidth: "250px", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" },
                        sortable: true,
                    },
                    {
                        body: (item) => {
                            const tag = getStatusTag(item);
                            return <Tag severity={tag.type} icon={tag.icon} />;
                        },
                        header: "Архивные",
                        style: { width: "10%" },
                        sortable: false,
                    },
                ]}
            />
        );
    }),
);

export default ProjectsList;
